import React from 'react';
import { FeatureCardProps } from '@interfaces/KnowledgeTransfer';
import styles from './FeatureCard.module.scss';

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  imageUrl,
  alternateName,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
        <img src={imageUrl} alt={alternateName} className={styles.imageClass} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export { FeatureCard };
